// extracted by mini-css-extract-plugin
export default {"McaRefreshLoader":"McaRefreshLoader_McaRefreshLoader__fcky6"};